
const URL_REMOTE = `https://apis.edulab.lk`;
const conf = {
  serverUrl:  URL_REMOTE,
  basePath: `chemistryfirst/v1`,
  redirect: `https://chemistryfirst.lk`,
};

// const URL_REMOTE = `https://teachme.ceyentra.lk`;
//
// const conf = {
//   serverUrl:  URL_REMOTE,
//   basePath: `api/v1`,
//   redirect: `https://teachme.ceyentra.lk/new-leeds`
// };

export default conf;
